import { render, staticRenderFns } from "./modelDetailDrawer.vue?vue&type=template&id=63447404&scoped=true"
import script from "./modelDetailDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./modelDetailDrawer.vue?vue&type=script&setup=true&lang=js"
import style0 from "./modelDetailDrawer.vue?vue&type=style&index=0&id=63447404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63447404",
  null
  
)

export default component.exports